"use client";

import classNames from "classnames";
import Link from "next/link";
import React from "react";
import { Breadcrumbs as MateralBreadcrumbs } from "@material-tailwind/react";

type Item = {
  title: string;
  href?: string;
};

interface BreadcrumbsProps {
  items: Item[];
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
  const LinkComponent = ({
    item,
    index,
    isLast,
  }: {
    item: Item;
    index: number;
    isLast: boolean; // Add a prop to check if it's the last item
  }) => {
    const { href, title } = item;

    const linkClass = classNames(
      "text-paragraph text-xs md:text-base font-normal leading-normal !no-underline",
      {
        //"!font-semibold": index === 0,
        "text-gray-lighter": isLast,
      }
    );

    return href ? (
      <Link href={href} className={linkClass}>
        {title.charAt(0).toUpperCase() + title.slice(1)}
      </Link>
    ) : (
      <div
        className={classNames(
          "font-normal leading-normal text-xs md:text-base",
          {
            //"!font-semibold": index === 0,
            "text-gray-lighter": isLast,
          }
        )}
      >
        {title.charAt(0).toUpperCase() + title.slice(1)}
      </div>
    );
  };

  return (
    <div className="w-full py-6 bg-neutral-100 flex-col justify-start items-start gap-2.5 inline-flex overflow-hidden md:mb-6">
      <div className="container">
        <div className="block justify-start items-center gap-1 md:inline-flex flex-wrap w-full overflow-x-scroll scrollbar-hide relative">
          <div className="absolute top-0 right-0 h-full w-10 bg-gradient-to-l from-gray-ultra-light to-transparent pointer-events-none"></div>{" "}
          <MateralBreadcrumbs className="!bg-transparent px-0 py-0 w-full !my-0 list-none breadcrumbs">
            {items.map((item, index) => (
              <LinkComponent
                key={index}
                item={item}
                index={index}
                isLast={index === items.length - 1} // Check if it's the last item
              />
            ))}
          </MateralBreadcrumbs>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumbs;
